import { FC } from "react";
import { makeStyles } from "tss-react/mui";
import { Box, Typography } from "@mui/material";

export const StatusDisplayChip: FC<StatusDisplayChipProps> = ({
  statusName,
  statusColor,
}) => {
  const { classes } = useStyles();

  return (
    <Box
      className={classes.statusBadge}
      sx={{
        backgroundColor: statusColor,
      }}
    >
      <Typography className={classes.statusText}>{statusName}</Typography>
    </Box>
  );
};

interface StatusDisplayChipProps {
  statusName: string;
  statusColor: string;
}

const useStyles = makeStyles()((theme) => ({
  statusBadge: {
    padding: theme.spacing(0.5, 1.5),
    borderRadius: theme.spacing(1),
    whiteSpace: "nowrap",
  },
  statusText: {
    fontSize: theme.typography.caption.fontSize,
    color: theme.palette.common.white,
    fontWeight: theme.fontWeight.regular,
  },
}));
